/**
 * Portrait + background changer locale pack: es
 */

module.exports = {
  "portrait": {
    "overview": [
      "Miral AI Background Remover es gratis tras iniciar sesión y funciona bien con retratos de busto: fotos de LinkedIn, currículum, avatares de WeChat o Instagram y masters transparentes para fotos tipo carnet.",
      "Sube un JPG, PNG o WebP nítido de hasta 15 MB. La IA detecta a la persona automáticamente. Antes de descargar, amplía mechones, gafas, pendientes y la línea del cuello.",
      "Un PNG transparente no es una foto de carnet blanca o azul terminada. Guarda primero el master transparente; luego añade el color requerido y recorta al tamaño oficial."
    ],
    "practice": [
      "Empiezo con el original de cámara siempre que puedo. Las miniaturas de mensajería y los filtros de belleza fuertes suavizan el pelo y dificultan conservar las monturas.",
      "Siempre coloco el recorte sobre un lienzo claro y otro oscuro. Esa sola comprobación revela aureolas pálidas y mechones que faltan y que en la miniatura parecen bien."
    ],
    "compareIntro": "Usa esta guía para personas: avatares, fotos tipo carnet y headshots profesionales. Usa la guía de ecommerce para fondos blancos de producto, y la de cambio de fondo cuando quieras una escena de café u oficina tras el recorte.",
    "workflow": "Sube un retrato claro de hasta 15 MB, deja que la IA quite todo el fondo, revisa pelo y gafas, descarga un PNG transparente y luego añade blanco, azul o color de marca.",
    "scenarioIntro": "Elige el trabajo de retrato más cercano al tuyo y revisa los bordes que suelen fallar en ese caso.",
    "sec": {
      "tldrTitle": "Versión corta",
      "tldrCols": [
        "Lo que necesitas",
        "Detalles"
      ],
      "tldrRows": [
        [
          "Precio",
          "Miral AI Background Remover es gratis tras iniciar sesión"
        ],
        [
          "Subida",
          "JPG, PNG o WebP de hasta 15 MB"
        ],
        [
          "Ideal para",
          "Headshots LinkedIn, fotos de CV, avatares, masters de carnet"
        ],
        [
          "Descarga",
          "PNG transparente; añade blanco o azul después"
        ],
        [
          "Revisar de cerca",
          "Pelo, gafas, pendientes, cuello y hombros"
        ],
        [
          "No es este artículo",
          "Los fondos blancos de producto van en la guía de ecommerce"
        ]
      ],
      "tldrP": "Un selfie de calle o una foto rápida de oficina también puede convertirse en un headshot limpio en Miral AI. Recorta una vez, guarda el archivo transparente y solo entonces crea la versión blanca, azul o de marca que realmente necesitas.",
      "whatTitle": "Qué necesitan avatares, fotos de carnet y headshots de LinkedIn",
      "whatP1": "Los tres usos comparten el primer paso: recorta a la persona con Miral AI Background Remover y guarda un PNG transparente limpio. La diferencia es el color y el recorte que añades después.",
      "whatAvatarP": "Qué resuelve quitar el fondo del avatar: los selfies de habitación y de calle entierran la cara en desorden. Quita el fondo, coloca el recorte sobre un color de marca o un plano, y previsualiza el crop circular para Instagram, WeChat o tu web.",
      "galleryAvatarCaption": "Ejemplo de avatar: a la izquierda un selfie interior desordenado; a la derecha el recorte sobre color sólido listo para crop redondo.",
      "whatIdP": "Qué resuelve quitar el fondo de la foto de carnet: las solicitudes suelen exigir blanco o azul. Una foto del salón suele fallar. Recorta una vez, añade el color requerido y recorta al tamaño oficial. Vuelve a comprobar las reglas actuales antes de enviar.",
      "galleryIdCaption": "Ejemplo de carnet: a la izquierda un fondo doméstico ocupado; a la derecha la misma persona sobre blanco puro para el recorte de tamaño.",
      "whatLinkedInP": "Qué resuelve el recorte para LinkedIn: las oficinas abiertas ponen monitores y compañeros detrás. Un fondo gris o blanco calmado devuelve la atención a la cara y la ropa — lo primero que nota un reclutador.",
      "galleryLinkedInCaption": "Ejemplo LinkedIn: a la izquierda un selfie de oficina ocupado; a la derecha el recorte sobre gris suave listo para un perfil profesional.",
      "whatTipTitle": "Un master transparente para los tres",
      "whatTipText": "Descarga primero el PNG transparente. Deriva el avatar de marca, la exportación blanca/azul de carnet y la tarjeta LinkedIn gris suave del mismo archivo.",
      "howTitle": "Cuatro pasos hasta un headshot usable",
      "howP": "Abre Miral AI Background Remover, sube una foto de busto, espera la detección automática y amplía al 100 % pelo y gafas antes de descargar. Añade blanco o azul solo cuando el borde esté limpio.",
      "howTipTitle": "Prefiere el archivo original",
      "howTipText": "Los filtros de belleza fuertes y la compresión de mensajería difuminan los mechones. El original de cámara casi siempre gana.",
      "edgeTitle": "Dónde suelen fallar los retratos",
      "edgeCols": [
        "Zona",
        "Fallo habitual",
        "Cómo comprobar"
      ],
      "edgeRows": [
        [
          "Mechones sueltos",
          "Se borran como fondo",
          "Ver en lienzos oscuro y claro"
        ],
        [
          "Gafas",
          "Patilla faltante o agujero en el cristal",
          "Ampliar las esquinas de la montura"
        ],
        [
          "Pendientes / cadenas finas",
          "Líneas metálicas rotas",
          "Seguir el borde de la joya"
        ],
        [
          "Cuello y línea de americana",
          "Aureola blanca u hombro dentado",
          "Colocar sobre lienzo oscuro"
        ],
        [
          "Barba o patillas",
          "Vello suavizado",
          "Reintentar con menos retoque en la fuente"
        ]
      ],
      "edgeP": "«Se ve bien» en miniatura no basta. La revisión a tamaño completo en dos colores de fondo es la prueba más rápida.",
      "useTitle": "Avatar, LinkedIn, CV y fotos tipo carnet",
      "useCols": [
        "Uso",
        "Fondo típico",
        "Nota práctica"
      ],
      "useRows": [
        [
          "LinkedIn / empleo",
          "Gris suave, blanco o desenfoque limpio",
          "Mantén la cara nítida; ganan los fondos tranquilos"
        ],
        [
          "Avatar WeChat / Instagram",
          "Color de marca o degradado simple",
          "Previsualiza el crop circular antes de publicar"
        ],
        [
          "Adjunto de CV",
          "Blanco o gris claro",
          "Deja espacio encima de la cabeza y bajo los hombros"
        ],
        [
          "Impresiones tipo carnet",
          "Blanco o azul",
          "Añade el color requerido sobre el PNG transparente y luego recorta"
        ],
        [
          "Pasaporte / visado",
          "Sigue las reglas oficiales actuales",
          "Color, expresión y gafas varían por país"
        ],
        [
          "Portadas de curso o directo",
          "Color de marca o escena después",
          "Recorta limpio primero y luego diseña la portada"
        ]
      ],
      "useTipTitle": "Las reglas cambian",
      "useTipText": "Las normas de visado y examen difieren por país y año. La herramienta limpia el sujeto; el cumplimiento viene de la checklist oficial.",
      "hairTitle": "Recorte de pelo y gafas",
      "hairItems": [
        "Los mechones a contraluz necesitan una fuente más simple y con más contraste.",
        "Con gafas, confirma que ambas patillas y la zona de los cristales siguen intactas.",
        "Pelo oscuro sobre pared oscura es un mal punto de partida: acércate a una pared más clara si puedes.",
        "Un jersey claro sobre pared blanca suele perder el hombro; cambia el fondo de la toma.",
        "Rizos largos y mechones de niños merecen un zoom obligatorio al 100 % antes de descargar."
      ],
      "hairP": "Las formas grandes de ropa rara vez arruinan un recorte de retrato. El pelo y las gafas sí. Ahí gasto el minuto extra.",
      "troubleTitle": "Cuando el headshot se ve mal",
      "troubleCols": [
        "Problema",
        "Causa probable",
        "Prueba esto"
      ],
      "troubleRows": [
        [
          "Faltan trozos de pelo",
          "Fuente suave, comprimida o a contraluz",
          "Usa un original más nítido con menos belleza"
        ],
        [
          "Borde pálido en cara u hombros",
          "Color del fondo viejo pegado al borde",
          "Confirma en lienzo oscuro y reintenta con más contraste"
        ],
        [
          "Montura rota",
          "Reflejos fuertes confunden el contorno",
          "Repite la foto con luz más suave en los cristales"
        ],
        [
          "La ropa se funde con la pared",
          "Bajo contraste sujeto/fondo",
          "Cambia el fondo en lugar de reenviar el mismo archivo"
        ],
        [
          "La foto de carnet se ve amarilla",
          "Balance de blancos cálido",
          "Recorta primero y neutraliza el color en el lienzo final"
        ]
      ],
      "troubleTipTitle": "Cambia la entrada",
      "troubleTipText": "Reenviar el mismo selfie suave casi nunca arregla el pelo. Una fuente más limpia suele hacerlo.",
      "prosConsTitle": "Dónde ayuda — y dónde sigues decidiendo",
      "bestTitle": "Hábitos que hacen usables los avatares",
      "bestItems": [
        "Encuadre de busto con un poco de espacio sobre el pelo.",
        "Expresión natural; evita el suavizado fuerte de piel antes del recorte.",
        "Revisa el PNG en lienzos claro y oscuro cada vez.",
        "Guarda master transparente, exportación de carnet coloreada y crop final como archivos separados.",
        "En plataformas de empleo, un fondo tranquilo hace más legibles cara y ropa.",
        "Si luego quieres ambiente de café u oficina, recorta limpio primero y sigue la guía de cambio de fondo."
      ],
      "miralTitle": "Qué hacer después del recorte",
      "miralP": "En Miral AI puedes reforzar el retrato, construir una tarjeta de avatar calmada o continuar en Seedream o FLUX.2 para una escena de portada. Para reemplazo lifestyle, abre la guía de cambio de fondo IA. Para blancos de producto, usa la guía de ecommerce.",
      "miralLinksTitle": "Siguientes pasos útiles",
      "miralLinks": [
        {
          "label": "Miral AI Background Remover",
          "path": "/tools/background-remover"
        },
        {
          "label": "Guía de cambio de fondo con IA",
          "path": "/hub/articles/ai-background-changer-online"
        },
        {
          "label": "Guía general de eliminación de fondo IA",
          "path": "/hub/articles/ai-background-remover-online"
        },
        {
          "label": "Guía de fondo de producto ecommerce",
          "path": "/hub/articles/ecommerce-product-background-removal"
        },
        {
          "label": "AI Image Enhancer",
          "path": "/tools/image-enhancer"
        },
        {
          "label": "Seedream 5",
          "path": "/image-models/seedream-ai-image-generator"
        },
        {
          "label": "FLUX.2",
          "path": "/image-models/flux-2-ai-image-generator"
        }
      ],
      "intentsTitle": "Flujos de retrato habituales",
      "faqTitle": "Preguntas antes de subir",
      "faqItems": [
        [
          "¿Cómo quitar el fondo de un retrato online gratis?",
          "Inicia sesión en Miral AI, sube un JPG, PNG o WebP de busto y descarga el PNG transparente."
        ],
        [
          "¿Cómo hacer una foto de carnet blanca o azul desde un selfie?",
          "Exporta primero un PNG transparente, añade el blanco o azul requerido, recorta al tamaño oficial y vuelve a comprobar las reglas actuales antes de enviar."
        ],
        [
          "¿Cómo hacer un headshot de LinkedIn con eliminación de fondo?",
          "Quita el fondo de oficina ocupado, coloca el recorte sobre gris suave o blanco y confirma pelo y hombros antes de subir."
        ],
        [
          "¿Puedo quitar gratis el fondo de un avatar de WeChat o Instagram?",
          "Sí. Inicia sesión, procesa el original del avatar y previsualiza un crop circular sobre tu color de marca."
        ],
        [
          "¿Es posible recortar online una foto con gafas?",
          "Sí, pero amplía montura, patillas y zona de cristales antes de descargar."
        ],
        [
          "¿Qué herramienta usar para recortar pelo en retratos?",
          "Usa Miral AI Background Remover con el original de cámara y revisa mechones en lienzos claro y oscuro."
        ],
        [
          "¿Qué herramienta para preparar el fondo de una foto de pasaporte?",
          "Haz primero un master de retrato transparente y luego exporta el color y el tamaño en milímetros oficiales."
        ],
        [
          "¿Cómo arreglar una aureola blanca tras quitar el fondo del retrato?",
          "Coloca el PNG transparente sobre un lienzo oscuro para localizar el borde y reintenta con un original más nítido y contrastado."
        ],
        [
          "¿Cómo arreglar mechones faltantes en rizos o fotos de niños?",
          "Evita belleza fuerte y miniaturas de chat. Usa un original más claro y revisa al 100 % antes de descargar."
        ],
        [
          "¿Puedo procesar muchos headshots profesionales a la vez?",
          "La página actual procesa una imagen cada vez para poder revisar cada borde de pelo."
        ],
        [
          "¿Cuál es la diferencia entre fondo de carnet transparente y blanco?",
          "Un PNG transparente puede recibir cualquier color después. Una exportación blanca ya contiene píxeles blancos para formularios y CV."
        ],
        [
          "¿Cómo cambiar después el fondo a una escena de café u oficina?",
          "Cuando el PNG transparente pase la revisión, sigue la guía de cambio de fondo IA y comprueba que la luz coincida."
        ]
      ]
    },
    "linksTitle": "Continuar en Miral AI",
    "linksIntro": "Guarda el master de retrato transparente; luego mejóralo, crea una tarjeta de avatar o pasa a una escena lifestyle.",
    "links": [
      {
        "label": "Miral AI Background Remover",
        "path": "/tools/background-remover"
      },
      {
        "label": "Guía de cambio de fondo con IA",
        "path": "/hub/articles/ai-background-changer-online"
      },
      {
        "label": "Guía general de eliminación de fondo IA",
        "path": "/hub/articles/ai-background-remover-online"
      },
      {
        "label": "Guía de fondo de producto ecommerce",
        "path": "/hub/articles/ecommerce-product-background-removal"
      },
      {
        "label": "AI Image Enhancer",
        "path": "/tools/image-enhancer"
      },
      {
        "label": "Seedream 5",
        "path": "/image-models/seedream-ai-image-generator"
      },
      {
        "label": "FLUX.2",
        "path": "/image-models/flux-2-ai-image-generator"
      }
    ],
    "steps": [
      {
        "title": "Elige una foto de busto clara",
        "text": "Usa un JPG, PNG o WebP de hasta 15 MB con cara y hombros completamente visibles."
      },
      {
        "title": "Quita el fondo automáticamente",
        "text": "Miral AI Background Remover detecta a la persona y limpia todo el fondo — sin contorno manual."
      },
      {
        "title": "Inspecciona pelo y gafas",
        "text": "Amplía mechones, monturas, pendientes y la línea del cuello."
      },
      {
        "title": "Descarga el PNG transparente y añade color",
        "text": "Guarda el master y luego añade blanco, azul, gris o color de marca para el uso final."
      }
    ],
    "pros": [
      "Pensado para bordes de retrato en avatares y fotos tipo carnet",
      "Sin herramienta de pluma de Photoshop para el pelo",
      "Un PNG transparente puede convertirse en muchos colores de fondo",
      "Procesamiento gratis en el navegador tras iniciar sesión"
    ],
    "cons": [
      "El pelo fino sigue necesitando revisión a tamaño completo",
      "El contraluz o el bajo contraste pueden suavizar los bordes",
      "Una imagen cada vez en la página actual",
      "Las reglas oficiales de carnet siguen exigiendo comprobación manual"
    ],
    "tips": [
      {
        "title": "Comprueba dos colores de lienzo",
        "text": "Fondos claro y oscuro revelan rápido aureolas y mechones faltantes."
      },
      {
        "title": "Protege gafas y joyas",
        "text": "Amplía patillas, esquinas de cristal y cadenas finas antes de descargar."
      },
      {
        "title": "Separa master y exportación de carnet",
        "text": "No sobrescribas el PNG transparente con un archivo blanco o azul aplanado."
      },
      {
        "title": "Mantén los filtros ligeros",
        "text": "La belleza fuerte suaviza los bordes exactos que el modelo necesita."
      },
      {
        "title": "Sabe qué guía abrir después",
        "text": "Reemplazo de escena → cambiador de fondo. Blancos de producto → guía de ecommerce."
      }
    ],
    "scenarios": [
      {
        "title": "Eliminación de fondo para headshot de LinkedIn",
        "text": "Recorta un busto nítido y colócalo sobre gris suave o blanco antes de subir."
      },
      {
        "title": "Recorte de avatar WeChat o Instagram",
        "text": "Descarga un PNG transparente y previsualiza el crop circular sobre tu color de marca."
      },
      {
        "title": "Foto de CV con fondo blanco",
        "text": "Guarda el master transparente y exporta un archivo de fondo blanco aparte para el PDF."
      },
      {
        "title": "Foto tipo carnet con fondo azul",
        "text": "Añade el azul requerido solo cuando el borde del pelo esté limpio."
      },
      {
        "title": "Quitar el fondo alrededor del pelo online",
        "text": "Usa el original de cámara y revisa mechones en lienzos claro y oscuro."
      },
      {
        "title": "Recorte de retrato con gafas",
        "text": "Amplía esquinas de montura y patillas antes de confiar en la descarga."
      },
      {
        "title": "Preparación de foto de pasaporte",
        "text": "Haz primero el PNG transparente y sigue tamaño y color actuales del país."
      },
      {
        "title": "De selfie de oficina a headshot profesional",
        "text": "Quita el desorden del pasillo, mantén expresión natural y evita filtros fuertes."
      },
      {
        "title": "Recorte de niños o pelo rizado",
        "text": "Espera más mechones; revisa siempre al 100 %."
      },
      {
        "title": "Fondo de retrato transparente vs blanco",
        "text": "El transparente se reutiliza; el blanco es una exportación aplanada para un formulario concreto."
      },
      {
        "title": "Arreglar aureola blanca en un recorte de cara",
        "text": "Confirma el borde en lienzo oscuro y reintenta con más contraste en la fuente."
      },
      {
        "title": "Del recorte de retrato a una escena de café",
        "text": "Usa la guía de cambio de fondo cuando el PNG transparente pase la revisión."
      }
    ],
    "toolFaq": [
      {
        "q": "¿Cómo quitar el fondo de un retrato online gratis?",
        "a": "Inicia sesión, sube un retrato y descarga el PNG transparente sin software de escritorio."
      },
      {
        "q": "¿Cómo hacer una foto de carnet blanca o azul desde un selfie?",
        "a": "Quita el fondo, guarda el PNG transparente, añade el color requerido y recorta al tamaño oficial."
      },
      {
        "q": "¿Puedo quitar gratis el fondo de un avatar de WeChat o Instagram?",
        "a": "Sí. Procesa el original tras iniciar sesión y previsualiza el crop circular sobre tu color de marca."
      },
      {
        "q": "¿Es posible recortar online una foto con gafas?",
        "a": "Sí, pero revisa patillas y zonas de cristal a tamaño completo antes de descargar."
      },
      {
        "q": "¿Qué herramienta usar para recortar pelo en retratos?",
        "a": "Usa Miral AI Background Remover con un original nítido e inspecciona mechones en lienzos claro y oscuro."
      },
      {
        "q": "¿Qué herramienta para preparar el fondo de una foto de pasaporte?",
        "a": "Crea primero un master de retrato transparente y exporta el color y tamaño exigidos por el formulario."
      },
      {
        "q": "¿Cómo arreglar una aureola blanca tras quitar el fondo del retrato?",
        "a": "Confirma el borde en lienzo oscuro y reintenta con una fuente más nítida y contrastada."
      },
      {
        "q": "¿Cómo arreglar mechones faltantes en rizos o fotos de niños?",
        "a": "Evita belleza fuerte y miniaturas de chat; usa un original más claro y revisa al 100 %."
      },
      {
        "q": "¿Puedo procesar muchos headshots profesionales a la vez?",
        "a": "La página actual procesa una imagen cada vez."
      },
      {
        "q": "¿Cómo cambiar después el fondo a una escena de café?",
        "a": "Usa el PNG transparente revisado con el flujo de cambio de fondo IA."
      }
    ]
  },
  "changer": {
    "overview": [
      "Cambiar el fondo funciona mejor en dos pasos: eliminación gratuita a un PNG transparente limpio y luego colocación en una nueva escena — luz de café, oficina tranquila, muro de marca o luz diurna exterior.",
      "Miral AI Background Remover se encarga del recorte. Seedream o FLUX.2 pueden construir escenas lifestyle después. No lo confundas con placas de producto blanco puro estilo Amazon; ese flujo está en la guía de ecommerce.",
      "Si el recorte aún tiene un borde pálido, cualquier escena nueva se verá falsa. Arregla primero los bordes y luego la atmósfera."
    ],
    "practice": [
      "Me niego a componer hasta que el sujeto transparente se vea limpio en un lienzo claro y otro oscuro.",
      "Hago coincidir la dirección de la luz antes que lo «bonito». Un retrato con luz de ventana sobre una calle de neón nocturna casi nunca engaña."
    ],
    "compareIntro": "Usa la eliminación de fondo para el master transparente, esta guía para escenas lifestyle o portadas, la guía de retrato para colores tipo carnet y la de ecommerce para fondos blancos de marketplace.",
    "workflow": "Recorta el sujeto, elige una escena alineada con la iluminación, compón o genera el nuevo entorno y revisa sombras de contacto, temperatura de color y bordes antes de exportar.",
    "scenarioIntro": "Elige primero el objetivo de la escena y mantén el master transparente separado de cada crop final.",
    "sec": {
      "tldrTitle": "El orden que realmente funciona",
      "tldrCols": [
        "Paso",
        "Conservar",
        "Cuidado"
      ],
      "tldrRows": [
        [
          "1. Quitar fondo",
          "Master PNG transparente de Miral AI",
          "Las aureolas viejas arruinan cada escena posterior"
        ],
        [
          "2. Elegir escena",
          "Café, oficina, muro de marca, exterior",
          "Elige por el trabajo, no por estética al azar"
        ],
        [
          "3. Componer o generar",
          "Imagen lifestyle o portada",
          "Alinea dirección de luz y temperatura"
        ],
        [
          "4. Revisar",
          "Exportación lista para publicar",
          "Bordes, escala y sensación de contacto"
        ],
        [
          "Separar de placas blancas",
          "Guía ecommerce para SKU blancos",
          "Este artículo es para reemplazo de escena"
        ]
      ],
      "tldrP": "Cambiar un fondo no es un filtro mágico único. En Miral AI aíslas el sujeto con Background Remover y luego le das un nuevo lugar. Si saltas el primer trabajo, el segundo casi siempre parece pegado.",
      "removeTitle": "Imágenes lifestyle, portadas sociales y carteles de evento necesitan cada uno una placa distinta",
      "removeP1": "Los colores viejos de pared se pegan al pelo y a los bordes de la chaqueta. El camino estable es el mismo: Miral AI Background Remover → master PNG transparente → nueva escena para el trabajo. Las placas blancas de producto de marketplace van en la guía de ecommerce, no aquí.",
      "removeLifestyleP": "Qué resuelve el cambio lifestyle: la luz de café, asientos junto a la ventana y rincones del hogar crean ambiente, pero un fondo original desordenado abarata todo el encuadre. Recorta limpio y coloca a la persona en una escena cuya luz coincida con la cara.",
      "galleryLifestyleCaption": "Ejemplo lifestyle: a la izquierda el master transparente; a la derecha la misma persona compuesta en una escena de café luminosa.",
      "removeSocialP": "Qué resuelve el cambio de portada social: Instagram, Xiaohongshu y cabeceras de LinkedIn necesitan cara clara y espacio para un título. Un dormitorio o una oficina abierta llenan el marco. Un degradado de marca o un muro de color calmado pone a la persona a un lado y deja el otro para el texto.",
      "gallerySocialCaption": "Ejemplo de portada social: a la izquierda el master transparente; a la derecha un muro en degradado de marca con espacio para un titular.",
      "removePosterP": "Qué resuelve el cambio de cartel de evento: webinars, lanzamientos de cursos y anuncios de charlas necesitan un escenario o muro de marca calmado, no un selfie de escritorio. Tras el recorte, coloca a la persona sobre una placa suave de marca con espacio para el título y añade tipografía en GPT Image si hace falta.",
      "galleryPosterCaption": "Ejemplo de cartel de evento: a la izquierda el master transparente; a la derecha un muro de marca suave apto para portada de charla o curso.",
      "removeTipTitle": "Separa master, escena y crops de portada",
      "removeTipText": "No sobrescribas el PNG transparente con una sola exportación de café o degradado. El cartel de la temporada siguiente debe reutilizar el mismo recorte.",
      "howTitle": "Un flujo online práctico",
      "howP": "Abre Miral AI Background Remover y consigue primero un sujeto transparente fiable. Luego elige el tipo de fondo: color sólido es lo más rápido, una placa fotográfica real el siguiente y un entorno generado por IA el más flexible. Antes de exportar, comprueba si la persona sigue iluminada por el mismo mundo que el fondo.",
      "howTipTitle": "La luz gana a la decoración",
      "howTipText": "Un fondo más calmado con luz alineada gana a una escena dramática que pelea con la cara.",
      "sceneTitle": "Ideas de escena que suelen funcionar",
      "sceneCols": [
        "Dirección",
        "Bueno para",
        "Cuidado"
      ],
      "sceneRows": [
        [
          "Café luminoso / asiento ventana",
          "Marca personal y portadas lifestyle",
          "Las bombillas cálidas pueden empujar la piel demasiado naranja"
        ],
        [
          "Oficina tranquila / estantería suave",
          "LinkedIn e imágenes de mentor de curso",
          "Los props del fondo deben quedar más quietos que la cara"
        ],
        [
          "Luz diurna exterior y vegetación",
          "Viajes, bienestar, posts lifestyle",
          "Evita un cenital duro de mediodía que pelee con el original"
        ],
        [
          "Muro de marca sólido o degradado suave",
          "Carteles de evento y cabeceras sociales",
          "Mantén contraste suficiente para texto superpuesto"
        ],
        [
          "Iluminación de escenario o keynote",
          "Anuncios de charlas",
          "Los flares no deben cortar la cara"
        ],
        [
          "Rincón lifestyle en casa",
          "Storytelling de producto suave",
          "Mantén perspectiva y escala de la persona coherentes"
        ]
      ],
      "sceneP": "Lo que funciona suele ser claro, no abarrotado. Una persona limpia sobre un fondo calmado e intencional suele superar a un collage ocupado.",
      "qualityTitle": "Cinco sitios donde se nota lo falso",
      "qualityItems": [
        "Pelo y hombros: flecos blancos o de color de la habitación anterior.",
        "Dirección de luz: el highlight de la cara y la luz de ventana deben coincidir.",
        "Temperatura de color: piel de interior cálida sobre placa azul fría se ve partida.",
        "Escala: la persona no debe flotar como un sticker ni encogerse en una profundidad incorrecta.",
        "Contacto: un hint de suelo o silla hace creíble la composición."
      ],
      "qualityTipTitle": "Previsualiza el crop pronto",
      "qualityTipText": "Revisa un crop de avatar cuadrado y uno de portada ancha antes de comprometerte con la escena final.",
      "vsTitle": "Cómo se separa este artículo de los demás",
      "vsCols": [
        "Guía",
        "Trabajo principal",
        "Ábrela cuando"
      ],
      "vsRows": [
        [
          "Eliminador de fondo IA general",
          "Cualquier sujeto → PNG transparente",
          "Solo necesitas el recorte"
        ],
        [
          "Fondo de producto ecommerce",
          "Placas de producto blancas / transparentes",
          "Cumplimiento Amazon, Shopify"
        ],
        [
          "Eliminador de fondo de retrato",
          "Avatares y colores tipo carnet",
          "Caras, pelo, masters blanco/azul"
        ],
        [
          "Cambiador de fondo IA (este)",
          "Reemplazo de escena tras el recorte",
          "Ambiente de café, oficina, muro de marca"
        ]
      ],
      "vsP": "Cruza las cuatro guías, pero mantén las keywords honestas. Las placas blancas de producto no pertenecen a un artículo lifestyle, y las fotos de carnet azul de visado no pertenecen a un pitch de composición de café.",
      "troubleTitle": "Cuando la nueva escena se ve mal",
      "troubleCols": [
        "Problema",
        "Causa",
        "Arreglo"
      ],
      "troubleRows": [
        [
          "Fleco brillante alrededor del sujeto",
          "El recorte aún está sucio",
          "Vuelve a la eliminación con un original de más contraste"
        ],
        [
          "Parece un sticker",
          "Falta contacto o la luz no coincide",
          "Suaviza la placa o añade una sombra de contacto muy ligera"
        ],
        [
          "La piel se vuelve gris o naranja",
          "Choque de temperatura de color",
          "Elige una escena de temperatura más cercana o unifica el grade"
        ],
        [
          "El pelo se ve sucio",
          "Alpha incompleto alrededor de los mechones",
          "Limpia el recorte antes de volver a componer"
        ],
        [
          "La forma del producto deriva en una escena IA",
          "La generación cambió el objeto",
          "Fija la identidad; deja que la IA invente solo el entorno"
        ]
      ],
      "prosConsTitle": "Lo que desbloquea este flujo",
      "bestTitle": "Reemplazos que aguantan en la pantalla del móvil",
      "bestItems": [
        "Nunca te saltes el master transparente limpio.",
        "Deja que el canal decida la escena: contratación se queda tranquila, lifestyle puede respirar, carteles necesitan espacio para el título.",
        "Una iluminación de origen simple facilita el reemplazo.",
        "Previsualiza siempre en tamaño de móvil antes de publicar.",
        "Añade el texto del titular cuando la escena funcione: GPT Image puede ayudar con tipografía de cartel.",
        "Envía los SKU blancos de marketplace a la guía de ecommerce para separar intenciones."
      ],
      "miralTitle": "Mantén la cadena dentro de Miral AI",
      "miralP": "Ruta sugerida en Miral AI: Background Remover → Image Enhancer opcional → Seedream o FLUX.2 para el entorno → GPT Image si necesitas tipografía de cartel. Para tarjetas tipo carnet blancas o azules, vuelve a la guía de retrato.",
      "miralLinksTitle": "Siguientes pasos útiles",
      "miralLinks": [
        {
          "label": "Miral AI Background Remover",
          "path": "/tools/background-remover"
        },
        {
          "label": "Guía de retrato y foto de carnet",
          "path": "/hub/articles/ai-portrait-background-remover"
        },
        {
          "label": "Guía general de eliminación de fondo IA",
          "path": "/hub/articles/ai-background-remover-online"
        },
        {
          "label": "Guía de fondo de producto ecommerce",
          "path": "/hub/articles/ecommerce-product-background-removal"
        },
        {
          "label": "AI Image Enhancer",
          "path": "/tools/image-enhancer"
        },
        {
          "label": "Seedream 5",
          "path": "/image-models/seedream-ai-image-generator"
        },
        {
          "label": "FLUX.2",
          "path": "/image-models/flux-2-ai-image-generator"
        },
        {
          "label": "GPT Image 1.5",
          "path": "/image-models/gpt-image-ai-image-generator"
        }
      ],
      "intentsTitle": "Trabajos habituales de cambio de fondo",
      "faqTitle": "Preguntas prácticas",
      "faqItems": [
        [
          "¿Cómo cambiar el fondo de una foto online gratis?",
          "Inicia sesión en Miral AI, exporta un PNG transparente con Background Remover y coloca el sujeto sobre un café, muro de marca o nueva escena."
        ],
        [
          "¿Cómo hacer una imagen lifestyle desde un PNG transparente?",
          "Compón sobre una placa con luz alineada, revisa contacto y temperatura, y separa master y crops de portada."
        ],
        [
          "¿Cómo cambiar el fondo de una portada social tras el recorte?",
          "Cuando los bordes del pelo pasen la revisión, coloca el sujeto a un lado de un degradado de marca y deja espacio para el título."
        ],
        [
          "¿Puedo reemplazar el fondo de un selfie por una escena de café?",
          "Sí. Recorta limpio primero y compón en una placa de café cuya luz de ventana coincida con la cara."
        ],
        [
          "¿Es posible generar una nueva escena IA detrás de una persona real?",
          "Sí. Conserva el sujeto real del PNG transparente y deja que Seedream o FLUX.2 inventen solo el entorno."
        ],
        [
          "¿Qué herramienta usar para reemplazar el fondo de un cartel de evento?",
          "Usa Miral AI Background Remover para el recorte, colócalo sobre un muro de marca suave y añade el titular en GPT Image si hace falta."
        ],
        [
          "¿Qué herramienta para reemplazar el fondo de una portada social?",
          "Background Remover más un muro de color de marca o degradado. Continúa en Seedream o FLUX.2 cuando necesites una escena lifestyle más completa."
        ],
        [
          "¿Cómo arreglar una composición de fondo que se ve falsa?",
          "Inspecciona fleco, dirección de luz y temperatura en ese orden. Si los bordes están sucios, vuelve primero a la eliminación de fondo."
        ],
        [
          "¿Cómo arreglar un desajuste de luz diurna exterior al cambiar fondos?",
          "Alinea la dirección del sol; evita un cenital duro de mediodía sobre una cara iluminada para interior."
        ],
        [
          "¿Puedo usar el cambio de fondo para una portada de vídeo?",
          "Sí. Exporta el crop con el ratio de la portada y mantén el sujeto dentro del área segura."
        ],
        [
          "¿Cuál es la diferencia entre eliminar y cambiar el fondo?",
          "Eliminar te da un sujeto transparente. Cambiar coloca ese sujeto en una nueva escena o color."
        ],
        [
          "¿Puedo usar esto para fondos blancos de producto de Amazon?",
          "No. Las placas blancas de marketplace van en la guía de ecommerce; este artículo es para escenas lifestyle y portadas."
        ]
      ]
    },
    "linksTitle": "Construye el flujo de escena en Miral AI",
    "linksIntro": "Recorta una vez, guarda el master transparente y crea escenas lifestyle, portadas o placas de cartel sin rehacer la máscara.",
    "links": [
      {
        "label": "Miral AI Background Remover",
        "path": "/tools/background-remover"
      },
      {
        "label": "Guía de retrato y foto de carnet",
        "path": "/hub/articles/ai-portrait-background-remover"
      },
      {
        "label": "Guía general de eliminación de fondo IA",
        "path": "/hub/articles/ai-background-remover-online"
      },
      {
        "label": "Guía de fondo de producto ecommerce",
        "path": "/hub/articles/ecommerce-product-background-removal"
      },
      {
        "label": "AI Image Enhancer",
        "path": "/tools/image-enhancer"
      },
      {
        "label": "Seedream 5",
        "path": "/image-models/seedream-ai-image-generator"
      },
      {
        "label": "FLUX.2",
        "path": "/image-models/flux-2-ai-image-generator"
      },
      {
        "label": "GPT Image 1.5",
        "path": "/image-models/gpt-image-ai-image-generator"
      }
    ],
    "steps": [
      {
        "title": "Recorta primero un sujeto limpio",
        "text": "Usa Miral AI Background Remover para descargar un PNG transparente y confirmar bordes de pelo o producto."
      },
      {
        "title": "Decide la sensación de la nueva escena",
        "text": "Café, oficina tranquila, luz diurna exterior o muro de marca: elige según el canal."
      },
      {
        "title": "Coloca el sujeto en el nuevo fondo",
        "text": "Compón en un lienzo de diseño o continúa en Seedream / FLUX.2 con luz alineada."
      },
      {
        "title": "Revisa luz, escala y contacto",
        "text": "Busca flecos, choque de color, tamaño incorrecto y falta de contacto."
      },
      {
        "title": "Exporta el crop que necesitas",
        "text": "Guarda tamaños de portada y avatar por separado y deja intacto el master transparente."
      }
    ],
    "pros": [
      "Un master transparente sostiene muchas escenas",
      "Más barato que volver a fotografiar cada entorno",
      "Encaja bien en portadas sociales y marcos lifestyle",
      "Conecta limpiamente con el trabajo de escena de Seedream y FLUX.2"
    ],
    "cons": [
      "Una luz desalineada se lee falsa de inmediato",
      "Bordes de recorte sucios arruinan toda la composición",
      "Los SKU blancos de marketplace deben usar la guía de ecommerce",
      "Escenas de perspectiva compleja pueden seguir necesitando acabado manual"
    ],
    "tips": [
      {
        "title": "Bordes antes que atmósfera",
        "text": "Nunca compongas un recorte que aún muestre aureola en un lienzo oscuro."
      },
      {
        "title": "Alinea primero la luz",
        "text": "Elige placas cuya luz clave coincida con la cara o el producto."
      },
      {
        "title": "Separa los masters",
        "text": "PNG transparente, exportación lifestyle y crops sociales deben ser archivos distintos."
      },
      {
        "title": "Deja sitio para el texto",
        "text": "Los fondos de cartel necesitan zonas más calmadas donde quepa un titular."
      },
      {
        "title": "Separa intenciones de búsqueda",
        "text": "Envía placas blancas de Amazon al artículo de ecommerce; mantén este para cambio de escena."
      }
    ],
    "scenarios": [
      {
        "title": "Reemplazar fondo de foto online gratis",
        "text": "Recorta primero el sujeto y colócalo sobre una placa nueva o una escena generada."
      },
      {
        "title": "Fondo lifestyle de café para retrato",
        "text": "Usa una placa con luz de ventana que coincida con la iluminación de la cara."
      },
      {
        "title": "Fondo de oficina para foto profesional",
        "text": "Mantén estanterías y props más suaves que la persona."
      },
      {
        "title": "Fondo de color de marca para portada social",
        "text": "PNG transparente sobre sólido o degradado suave con espacio para el título."
      },
      {
        "title": "Cambiar fondo tras recorte IA",
        "text": "No compongas hasta que pelo y bordes de chaqueta pasen la revisión de dos lienzos."
      },
      {
        "title": "Escena IA generada detrás de una persona real",
        "text": "Deja que Seedream o FLUX.2 inventen la habitación, no una cara o ropa nuevas."
      },
      {
        "title": "Reemplazo de fondo de cartel de evento",
        "text": "Prefiere muros de marca limpios para que el titular se lea."
      },
      {
        "title": "Cambio de fondo con luz diurna exterior",
        "text": "Alinea la dirección del sol; evita cenital de mediodía sobre una cara suave de interior."
      },
      {
        "title": "Arreglar una composición de fondo falsa",
        "text": "Inspecciona fleco, dirección de luz y temperatura en ese orden."
      },
      {
        "title": "De PNG transparente a imagen lifestyle",
        "text": "Archiva el master y exporta crops de portada por separado."
      },
      {
        "title": "No para fondos blancos de Amazon",
        "text": "Envía las placas de listing a la guía de producto ecommerce."
      },
      {
        "title": "Recorte de retrato y luego cambio de escena",
        "text": "Termina la revisión de pelo en el flujo de retrato y luego abre este flujo de escena."
      }
    ],
    "toolFaq": [
      {
        "q": "¿Cómo cambiar el fondo de una foto online gratis?",
        "a": "Inicia sesión, quita el fondo original a un PNG transparente y coloca el sujeto en una nueva escena o color sólido."
      },
      {
        "q": "¿Cómo hacer una imagen lifestyle desde un PNG transparente?",
        "a": "Compón sobre una placa de luz alineada, revisa contacto y temperatura, y separa el master de los crops de portada."
      },
      {
        "q": "¿Puedo reemplazar el fondo de un selfie por una escena de café?",
        "a": "Sí. Recorta primero a la persona y compón en una placa de café con luz de ventana similar."
      },
      {
        "q": "¿Es posible generar una nueva escena IA detrás de una persona real?",
        "a": "Sí. Conserva el sujeto real y deja que Seedream o FLUX.2 creen solo el entorno."
      },
      {
        "q": "¿Qué herramienta usar para reemplazar el fondo de un cartel de evento?",
        "a": "Usa Background Remover para el recorte, colócalo sobre un muro de marca calmado y añade el titular si hace falta."
      },
      {
        "q": "¿Qué herramienta para reemplazar el fondo de una portada social?",
        "a": "Background Remover más muro de color de marca o degradado; continúa en Seedream o FLUX.2 para escenas lifestyle más ricas."
      },
      {
        "q": "¿Cómo arreglar una composición de fondo que se ve falsa?",
        "a": "Limpia el fleco, alinea la dirección de luz y unifica la temperatura antes de exportar."
      },
      {
        "q": "¿Cómo arreglar un desajuste de luz diurna exterior al cambiar fondos?",
        "a": "Alinea la dirección del sol y evita cenital de mediodía sobre una cara iluminada para interior."
      },
      {
        "q": "¿Puedo usar el cambio de fondo para una portada de vídeo?",
        "a": "Sí. Exporta el crop con el ratio de portada y mantén el sujeto dentro del área segura."
      },
      {
        "q": "¿Puedo usar esto para fondos blancos de producto de Amazon?",
        "a": "No. Usa la guía de fondo de producto ecommerce para placas blancas de marketplace."
      }
    ]
  },
  "articles": {
    "ai-portrait-background-remover": {
      "title": "Eliminador de fondo de retrato IA gratis para headshots, avatares y fotos de carnet",
      "excerpt": "Convierte un selfie ocupado en un headshot limpio: quita el fondo del retrato gratis, exporta un PNG transparente y añade blanco, azul o color de marca para LinkedIn, CV y avatares.",
      "metaTitle": "Eliminador de fondo de retrato IA gratis | Miral",
      "metaDescription": "Quita fondos de retrato gratis con Miral AI. Conserva el detalle del pelo, exporta PNG transparentes y crea headshots de LinkedIn o fotos tipo carnet blancas y azules.",
      "target": {
        "label": "Abrir eliminador de fondo de retrato",
        "path": "/tools/background-remover"
      },
      "keywords": [
        "eliminador fondo retrato gratis",
        "quitar fondo headshot IA",
        "fondo foto LinkedIn",
        "fondo foto carnet",
        "quitar fondo avatar",
        "quitar fondo alrededor del pelo",
        "foto CV fondo blanco",
        "foto carnet fondo azul online"
      ]
    },
    "ai-background-changer-online": {
      "title": "Cambiador de fondo IA gratis: estilo de vida, portadas sociales y carteles",
      "excerpt": "Quita el fondo viejo gratis y coloca personas en escenas de estilo de vida de café, portadas con degradado de marca o muros de cartel — sin competir con la intención de fondo blanco de ecommerce.",
      "metaTitle": "Cambiador de fondo IA gratis online | Miral",
      "metaDescription": "Cambia fondos de foto online con Miral AI: recorta a PNG transparente y crea escenas de estilo de vida de café, portadas sociales y carteles de evento.",
      "target": {
        "label": "Abrir eliminador de fondo IA",
        "path": "/tools/background-remover"
      },
      "keywords": [
        "cambiador fondo IA gratis",
        "reemplazar fondo foto online",
        "cambiar fondo tras recorte",
        "reemplazo de escena IA",
        "cambiador fondo lifestyle",
        "fondo café para retrato",
        "reemplazo fondo portada social",
        "PNG transparente nuevo fondo"
      ]
    }
  }
}
